import { useLocation, useNavigate } from "react-router-dom";
import Logo from "./Logo";
import { scrollToSection } from "../lib/smooth";

const SECTOR_LINKS = ["App Dev", "Manufacturing", "Clean Energy", "Smart Agri", "Real Estate"];
const COMPANY_LINKS = [
  { label: "Corporate Profile", target: "#vision" },
  { label: "Ecosystem News", page: "/insights" },
  { label: "Contact Bureau", page: "/bureau" },
];
const LEGAL_LINKS = ["Privacy Policy", "Terms of Use"];

const Footer = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const go = (target) => {
    if (location.pathname === "/") {
      scrollToSection(target);
    } else {
      navigate("/", { state: { scrollTo: target } });
    }
  };

  return (
    <footer
      className="border-t border-white/10 bg-[#07080B] pt-24 md:pt-32"
      data-testid="site-footer"
    >
      <div className="mx-auto max-w-[1600px] px-6 md:px-12">
        <div className="grid grid-cols-1 gap-16 pb-20 md:grid-cols-12">
          <div className="md:col-span-6">
            <Logo />
            <p className="mt-8 font-mono text-[10px] uppercase tracking-[0.3em] text-white/35">
              FUTURE FACTORY GROUP // EST. 2026
            </p>
            <p className="mt-3 font-display text-2xl font-medium tracking-tight text-white/70 md:text-3xl" data-testid="footer-tagline">
              Engineering Tomorrow.
            </p>
          </div>

          <div className="md:col-span-3">
            <p className="font-mono text-[10px] uppercase tracking-[0.35em] text-cyber">Sectors</p>
            <ul className="mt-6 space-y-4">
              {SECTOR_LINKS.map((label, i) => (
                <li key={label}>
                  <button
                    data-testid={`footer-sector-link-${i}`}
                    onClick={() => go("#sectors")}
                    className="text-sm text-secondary transition-colors duration-300 hover:text-neon"
                  >
                    {label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-3">
            <p className="font-mono text-[10px] uppercase tracking-[0.35em] text-cyber">Company</p>
            <ul className="mt-6 space-y-4">
              {COMPANY_LINKS.map((link, i) => (
                <li key={link.label}>
                  <button
                    data-testid={`footer-company-link-${i}`}
                    onClick={() => (link.page ? navigate(link.page) : go(link.target))}
                    className="text-sm text-secondary transition-colors duration-300 hover:text-neon"
                  >
                    {link.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="flex flex-col gap-6 border-t border-white/10 py-8 md:flex-row md:items-center md:justify-between">
          <div className="flex gap-8">
            {LEGAL_LINKS.map((label, i) => (
              <button
                key={label}
                data-testid={`footer-legal-link-${i}`}
                className="font-mono text-[10px] uppercase tracking-[0.25em] text-white/35 transition-colors duration-300 hover:text-cyber"
              >
                {label}
              </button>
            ))}
          </div>
          <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-white/35" data-testid="footer-copyright">
            © 2026 Future Factory Group. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
